export class Notification {
  public Reference: string;
  public Message: string;
  public Detail: string;
  public Sender: string;
  public Severity: Severity;
  public Acknowledged: Boolean;
  public AutoAcknowledge: Boolean;
  public Arrived: Date;
  public IsCentered: Boolean;
}

export class Severity {

  public static primary = new Severity('primary');
  public static secondary = new Severity('secondary');
  public static success = new Severity('success');
  public static error = new Severity('danger');
  public static errornolog = new Severity('danger');
  public static warning = new Severity('warning');
  public static info = new Severity('info');
  public static trace = new Severity('light');
  public static debug = new Severity('dark');

  public readonly Name: string;
  private constructor(private severity: string) {
    this.Name = this.severity;
  }

}



// WEBPACK FOOTER //
// ./src/app/common/notification.service/notification.model.ts